<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { requiredIf, url } from "vuelidate/lib/validators";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "مواقع التواصل الاجتماعي",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError,  VueContentLoading },
  data() {
    return {
     
      title: "مواقع التواصل الاجتماعي",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "مواقع التواصل الاجتماعي",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      socials: {},

      submitadd: false,
      loadingButton: false,
      loadingContent: false
    };
  },
  validations: {
    socials: {
      facebook: {url: {url, required: requiredIf( function() { return this.socials.facebook.published; })  }},
      twitter: {url: {url, required: requiredIf( function() { return this.socials.twitter.published; })  }},
      instagram: {url: {url, required: requiredIf( function() { return this.socials.instagram.published; }) }},
      youtube: {url: {url, required: requiredIf( function() { return this.socials.youtube.published; }) }},
      telegram: {url: {url, required: requiredIf( function() { return this.socials.telegram.published; }) }},
    },
  },
  computed:{
    ...mapGetters('socialMedia', ['getSocials'])
  },
  methods: {
    ...mapActions("socialMedia", [ 'getAll', 'edit']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    saveSocials() {
      this.submitadd = true;
      this.$v.$touch();
      if(this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      

      alert(this.socials.facebook.toJson())
      Promise.all([
        this.edit({
          id: this.socials.facebook.id,
          social: this.socials.facebook.toJson()
        }),
        this.edit({
          id: this.socials.twitter.id,
          social: this.socials.twitter.toJson()
        }),
        this.edit({
          id: this.socials.instagram.id,
          social: this.socials.instagram.toJson()
        }),
        this.edit({
          id: this.socials.youtube.id,
          social: this.socials.youtube.toJson()
        }),
        this.edit({
          id: this.socials.telegram.id,
          social: this.socials.telegram.toJson()
        }),
      ])
      .then((response)=>{
        swal.success(response[0].data.message)
        this.loadingButton = false
      })
      .catch((error)=>{
        this.handleError(error[0])
        this.loadingButton = false
      })
    }
  },
  created(){
    this.getAll()
    .then(()=>{
      this.socials = this.getSocials
      this.loadingContent = true
    })
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent" @submit.prevent="saveSocials">

              <AlertError :errors="errors"></AlertError>

              <div class="row mt-3 con-social">
                <b-form-group class="col-md-12 mb-3" label="فيسبوك : " label-for="facebook" >
                  <div class="input-group">
                    <label class="input-group-text"><i class="bx bxl-facebook-square font-size-20"></i></label>
                    <b-form-input id="facebook" v-model="socials.facebook.url" class="form-control" :class="{ 'is-invalid': submitadd && $v.socials.facebook.url.$error}" placeholder="ادخل رابط الفيسبوك" type="text" ></b-form-input>
                    <label class="input-group-text">
                      تفعيل <input class="mx-1" v-model="socials.facebook.published" type="checkbox" />
                    </label>
                    <div v-if="submitadd && $v.socials.facebook.url.$error" class="invalid-feedback">
                      <span v-if="!$v.socials.facebook.url.required"> قم بأدخال رابط الفيسبوك </span>
                      <span v-if="!$v.socials.facebook.url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="تويتر : " label-for="twitter" >
                  <div class="input-group">
                    <label class="input-group-text"><i class="bx bxl-twitter font-size-20"></i></label>
                    <b-form-input id="twitter" v-model="socials.twitter.url" class="form-control" :class="{ 'is-invalid': submitadd && $v.socials.twitter.url.$error}" placeholder="ادخل رابط تويتر" type="text" ></b-form-input>
                    <label class="input-group-text">
                      تفعيل <input class="mx-1" v-model="socials.twitter.published" type="checkbox" />
                    </label>
                    <div v-if="submitadd && $v.socials.twitter.url.$error" class="invalid-feedback">
                      <span v-if="!$v.socials.twitter.url.required"> قم بأدخال رابط تويتر </span>
                      <span v-if="!$v.socials.twitter.url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="إنستغرام : " label-for="instagram" >
                  <div class="input-group">
                    <label class="input-group-text"><i class="bx bxl-instagram-alt font-size-20"></i></label>
                    <b-form-input id="instagram" v-model="socials.instagram.url" class="form-control" :class="{ 'is-invalid': submitadd && $v.socials.instagram.url.$error}" placeholder="ادخل رابط الانستغرام" type="text" ></b-form-input>
                    <label class="input-group-text">
                      تفعيل <input class="mx-1" v-model="socials.instagram.published" type="checkbox" />
                    </label>
                    <div v-if="submitadd && $v.socials.instagram.url.$error" class="invalid-feedback">
                      <span v-if="!$v.socials.instagram.url.required"> قم بأدخال رابط الانستغرام </span>
                      <span v-if="!$v.socials.instagram.url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="يوتيوب : " label-for="youtube" >
                  <div class="input-group">
                    <label class="input-group-text"><i class="bx bxl-youtube font-size-20"></i></label>
                    <b-form-input id="youtube" v-model="socials.youtube.url" class="form-control" :class="{ 'is-invalid': submitadd && $v.socials.youtube.url.$error}" placeholder="ادخل رابط اليوتيوب" type="text" ></b-form-input>
                    <label class="input-group-text">
                      تفعيل <input class="mx-1" v-model="socials.youtube.published" type="checkbox" />
                    </label>
                    <div v-if="submitadd && $v.socials.youtube.url.$error" class="invalid-feedback">
                      <span v-if="!$v.socials.youtube.url.required"> قم بأدخال رابط اليوتيوب </span>
                      <span v-if="!$v.socials.youtube.url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="تيليجرام : " label-for="telegram" >
                  <div class="input-group">
                    <label class="input-group-text"><i class="bx bxl-telegram font-size-20"></i></label>
                    <b-form-input id="telegram" v-model="socials.telegram.url" class="form-control" :class="{ 'is-invalid': submitadd && $v.socials.telegram.url.$error}" placeholder="ادخل رابط التيليجرام" type="text" ></b-form-input>
                    <label class="input-group-text">
                      تفعيل <input class="mx-1" v-model="socials.telegram.published" type="checkbox" />
                    </label>
                    <div v-if="submitadd && $v.socials.telegram.url.$error" class="invalid-feedback">
                      <span v-if="!$v.socials.telegram.url.required"> قم بأدخال رابط التيليجرام </span>
                      <span v-if="!$v.socials.telegram.url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    </div>
                  </div>
                </b-form-group>

              </div>

              <div class="mt-3">
                <hr>
                <b-button :disabled="this.loadingButton" variant="primary" type="submit" class="me-2"> 
                  <b-spinner v-if="this.loadingButton" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i> حفظ التعديلات</span>
                </b-button>
              </div>
            </b-form>

            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" width="400" height="140" >
                <rect x="0" y="1" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="6" rx="1" ry="1" width="12" height="10" />
                <rect x="13" y="6" rx="1" ry="1" width="366" height="10" />
                <rect x="380" y="6" rx="1" ry="1" width="20" height="10" />
                <rect x="0" y="25" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="30" rx="1" ry="1" width="12" height="10" />
                <rect x="13" y="30" rx="1" ry="1" width="366" height="10" />
                <rect x="380" y="30" rx="1" ry="1" width="20" height="10" />
                <rect x="0" y="49" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="54" rx="1" ry="1" width="12" height="10" />
                <rect x="13" y="54" rx="1" ry="1" width="366" height="10" />
                <rect x="380" y="54" rx="1" ry="1" width="20" height="10" />
                <rect x="0" y="73" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="78" rx="1" ry="1" width="12" height="10" />
                <rect x="13" y="78" rx="1" ry="1" width="366" height="10" />
                <rect x="380" y="78" rx="1" ry="1" width="20" height="10" />
                <rect x="0" y="97" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="102" rx="1" ry="1" width="12" height="10" />
                <rect x="13" y="102" rx="1" ry="1" width="366" height="10" />
                <rect x="380" y="102" rx="1" ry="1" width="20" height="10" />
                <rect x="0" y="120" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="125" rx="1" ry="1" width="35" height="10" />
              </vue-content-loading>
            </div>
            

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>